import React from 'react';

// Components
import { TagV2Variant } from '@zola/zola-ui/src/components/Tag/TagV2';

// Types
import type { WBudgetItemPaymentView } from '@zola/svc-web-api-ts-client';

// Utils
import { isBeforeDate } from '@zola-helpers/client/dist/es/util/dateUtils';

// Styles
import { StyledTagV2 } from './BudgetPaymentTag.styles';

export type BudgetPaymentTagProps = {
  payment: WBudgetItemPaymentView;
};

enum BudgetPaymentTagType {
  OVERDUE = 'Overdue',
  PAID = 'Paid',
  UPCOMING = 'Upcoming',
}

const BudgetPaymentTag = ({ payment }: BudgetPaymentTagProps): JSX.Element | null => {
  const { due_at, paid_at, payment_type } = payment;
  const isPaid = payment_type === (('PAID' as unknown) as WBudgetItemPaymentView.PaymentTypeEnum);

  let type = BudgetPaymentTagType.UPCOMING;
  if (isPaid && paid_at) {
    type = BudgetPaymentTagType.PAID;
  } else if (!isPaid && due_at && isBeforeDate(due_at, new Date())) {
    type = BudgetPaymentTagType.OVERDUE;
  }

  const tagTypes = {
    [BudgetPaymentTagType.OVERDUE]: {
      variant: TagV2Variant.RED,
      text: BudgetPaymentTagType.OVERDUE,
    },
    [BudgetPaymentTagType.PAID]: {
      variant: TagV2Variant.GREEN,
      text: BudgetPaymentTagType.PAID,
    },
    [BudgetPaymentTagType.UPCOMING]: {
      variant: TagV2Variant.GRAY,
      text: BudgetPaymentTagType.UPCOMING,
    },
  };

  return <StyledTagV2 variant={tagTypes[type].variant}>{tagTypes[type].text}</StyledTagV2>;
};

export default BudgetPaymentTag;
